import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="10" height="10" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M5 5a2 2 0 100-4 2 2 0 000 4zM1 9c0-2.21 1.79-4 4-4s4 1.79 4 4" stroke="#fff" strokeMiterlimit="10" strokeLinecap="round" /></svg>);